import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

interface SearchBarProps {
  value: string;
  onChange: (newValue: string) => void;
  onSearch: () => void;
  onCancel?: () => void;
  placeholder?: string;
}

export default function SearchBar({
  value,
  onChange,
  onSearch,
  onCancel,
  placeholder = "검색어를 입력해 주세요",
}: SearchBarProps) {
  return (
    <div className="flex h-full items-center gap-1 bg-transparent">
      <form
        className="flex h-full min-w-[350px] items-center justify-between rounded-md border border-zinc-400 bg-white px-2 focus-within:border-black"
        onSubmit={(event) => {
          event.preventDefault();
          onSearch();
        }}
      >
        <input
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          className="flex-grow"
        />
        <MagnifyingGlassIcon
          className="h-5 w-5 cursor-pointer text-zinc-500 hover:text-black"
          onClick={onSearch}
        />
      </form>
      {!!onCancel && (
        <span
          className="flex h-full cursor-pointer items-center justify-center rounded-md px-3 py-1 font-bold text-zinc-500 transition-colors duration-200 hover:text-red-500"
          onClick={onCancel}
        >
          검색 취소
        </span>
      )}
    </div>
  );
}
